import React from 'react';

const Reach: React.FC = () => (
  <section className="py-24 bg-[#0A1628] text-white">
    <div className="max-w-7xl mx-auto px-6 space-y-6">
      <p className="text-[#C9A962] text-sm font-semibold">Based in Nigeria</p>
      <h2 className="text-4xl serif">Our Abuja Office</h2>
      <p className="text-lg text-white/70 max-w-2xl leading-relaxed">House 10, Road 111, Efab Estate, Apo, Abuja, FCT, Nigeria.</p>
      <p className="text-white/70 max-w-2xl leading-relaxed">Contact LeadBold Resource Consulting Ltd to discuss public sector training, governance workshops, and retreats for your institution.</p>
      <a href="mailto:leadboldng@gmail.com" className="inline-block text-[#C9A962] underline">Contact the Abuja office</a>
    </div>
  </section>
);
export default Reach;
